<template>
  <div>
    <headline-container headline="Advertisement" :breadcrumbs="[{text: 'Advertisement'}]">
      <div class="row" style="margin-top: 12px;">
        <div v-if="hasPermission('admin')" class="col-xs-12">
          <select-widget
              v-model="targetMetric"
              :options="[{value: 'ad_target', label: 'Target'}, {value: 'ad_management_target', label: 'Management Target'}]"
          ></select-widget>
        </div>

        <div class="col-xs-12">
          <div class="dashboard-date-widget">
            <date-widget :value="year" format="YYYY" original-format="YYYY" @input="navigate"></date-widget>

            <i class="dashboard-date-widget__icon fa fa-sort"></i>
          </div>
        </div>
      </div>
    </headline-container>

    <div class="container">
      <div class="row">
        <div class="col-sm-8">
          <index-number
              :year="year"
              :target-metric="targetMetric"
          />
        </div>

        <div class="col-sm-8">
          <revenue-number
              :year="year"
              :target-metric="targetMetric"
          />
        </div>

        <div class="col-sm-8">
          <difference-number
              :year="year"
              :target-metric="targetMetric"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-sm-24">
          <portal-overview
              :year="year"
              :target-metric="targetMetric"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-sm-24">
          <channel-type-trended-overview
              :year="year"
              :target-metric="targetMetric"
          ></channel-type-trended-overview>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-24">
          <ChannelTypeOverview
              :year="year"
              :target-metric="targetMetric"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.dashboard-date-widget {
  position: relative;
}

.dashboard-date-widget__icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
</style>

<script>
import ChannelTypeTrendedOverview from '@/pages/Dashboards/Advertisement/Panels/ChannelTypeTrendedOverview'
import ChannelTypeOverview from '@/pages/Dashboards/Advertisement/Panels/ChannelTypeOverview'
import DateWidget from '@/vendor/forms/FormGroups/Widgets/Date'
import DifferenceNumber from '@/pages/Dashboards/Advertisement/Panels/DifferenceNumber'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import IndexNumber from '@/pages/Dashboards/Advertisement/Panels/IndexNumber'
import Permissions from '@/mixins/Permissions'
import PortalOverview from '@/pages/Dashboards/Advertisement/Panels/PortalOverview'
import RevenueNumber from '@/pages/Dashboards/Advertisement/Panels/RevenueNumber'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'

export default {
  components: {
    ChannelTypeTrendedOverview,
    ChannelTypeOverview,
    DateWidget,
    DifferenceNumber,
    HeadlineContainer,
    IndexNumber,
    PortalOverview,
    RevenueNumber,
    SelectWidget,
  },

  mixins: [Permissions],

  props: {
    year: {
      required: true
    }
  },

  data() {
    return {
      targetMetric: 'ad_target'
    }
  },

  methods: {
    navigate(year) {
      this.$router.push(year)
    }
  }
}
</script>
